export default function HeaderMegaMenu() {
  const menu = document.querySelector<HTMLElement>(".js-desktop-header-menu");
  const items = menu?.querySelectorAll<HTMLDivElement>(".js-menu-item");

  if (items && items.length > 0) {
    items.forEach((item) => {
      const megaMenu = item.querySelector(".js-mega-menu-item");
      const level2items = item.querySelectorAll<HTMLAnchorElement>("[data-list-id]");
      const level3lists = item.querySelectorAll<HTMLUListElement>("[data-list]");

      if (megaMenu) {
        const links = megaMenu.querySelectorAll<HTMLAnchorElement>("a, button");

        const resetTabIndexes = () => {
          links.forEach((link) => {
            link.setAttribute("tabindex", "-1");
          });
          handleIsActive(0);
        };

        const setTabIndexes = (isVisible: boolean, setActiveDefault: boolean = true) => {
          links.forEach((link) => {
            if (isVisible) {
              link.setAttribute("tabindex", "0");
            } else {
              link.setAttribute("tabindex", "-1");
            }
          });

          if (setActiveDefault) {
            handleIsActive(0);
          }
        };

        const handleResetLevelTwo = () => {
          level2items.forEach((item) => {
            item.setAttribute("data-active", "false");
          });
        };

        const handleResetLevelThree = () => {
          level3lists.forEach((list) => {
            list.setAttribute("data-active", "false");
          });
        };

        const handleIsActive = (index: number) => {
          if (level2items[index]) {
            handleResetLevelTwo();
            handleResetLevelThree();
            level2items[index].setAttribute("data-active", "true");
          }

          if (level3lists[index]) {
            handleResetLevelThree();
            level3lists[index].setAttribute("data-active", "true");
          }
        };

        const handleLevel2Keydown = (e: KeyboardEvent, index: number) => {
          // if someone hits tab from level 2
          if (e.key === "Tab") {
            if (e.shiftKey) {
              if (index !== 0) {
                e.preventDefault();
                // set active level 2 item if someone hits shift/tab and it's not the first item in the list
                handleIsActive(index - 1);
                level2items[index - 1].focus();
              }
            } else {
              // check if there are level 3 child items
              if (handleHasLevelThreeItems(index)) {
                e.preventDefault();
                // set focus to level 3
                handleIsActive(index);
                handleFocusLevelThree(e, index);
              } else {
                // set next level 2 item to active if there are not level 3 items
                if (level2items[index + 1]) {
                  handleIsActive(index + 1);
                } else {
                  // if there isn't a level 3 item and there isn't a next level 2 item then the menu closes and active index is reset
                  resetTabIndexes();
                }
              }
            }
          }
        };

        const handleFocusParentLevel = (e: KeyboardEvent, index: number) => {
          if (e.key === "Tab" && e.shiftKey) {
            e.preventDefault();
            level2items[index].focus();
          }
        };

        const handleFocusNextLevel = (index: number) => {
          const activeIndex = index + 1;
          if (level2items[activeIndex]) {
            handleIsActive(activeIndex);
            level2items[activeIndex].focus();
          } else {
            // if there isn't a next level then the menu closes and resets the active index to 0
            resetTabIndexes();
            //   link.addEventListener("focusout", resetTabIndexes);
          }
        };

        const handleHasLevelThreeItems = (index: number) => {
          if (level3lists[index]) {
            const links = level3lists[index].querySelectorAll<HTMLAnchorElement>("a, button");

            if (links && links.length > 0) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        };

        const handleFocusLevelThree = (e: KeyboardEvent, index: number) => {
          if (level3lists[index]) {
            const links = level3lists[index].querySelectorAll<HTMLAnchorElement>("a, button");

            if (links && links.length > 0) {
              links.forEach((item, i) => {
                if (i === 0) {
                  e.preventDefault();
                  item.focus();
                }
              });
            }
          }
        };

        // primary nav event listeners
        item.addEventListener("mouseenter", () => setTabIndexes(true));
        item.addEventListener("mouseleave", () => setTabIndexes(false));
        item.addEventListener("focusin", () => setTabIndexes(true, false));

        // left column mega menu event listeners
        level2items.forEach((item, index) => {
          item.addEventListener("mouseenter", () => handleIsActive(index));
          item.addEventListener("keydown", (e: KeyboardEvent) => handleLevel2Keydown(e, index));
        });
        // right column link event listeners
        level3lists.forEach((list, index) => {
          const links = list.querySelectorAll<HTMLAnchorElement>("a, button");

          links.forEach((item, i) => {
            if (i === 0) {
              item.addEventListener("keydown", (e: KeyboardEvent) => handleFocusParentLevel(e, index));
            }

            if (i === links.length - 1) {
              item.addEventListener("focusout", () => handleFocusNextLevel(index));
            }
          });
        });
      }
    });
  }
}
